import {EmojiAutocomplete} from '@github-ui/emoji-autocomplete'
import {hpcAttrs} from '@github-ui/hpc'
import {useViewerSettings} from '@github-ui/use-viewer-settings'
import {FormControl, TextInput} from '@primer/react'
import {Suspense} from 'react'

import {LABELS} from './constants/labels'
import styles from './CreateIssueFormTitle.module.css'

type CreateIssueFormTitleProps = {
  title: string
  titleInputRef: React.RefObject<HTMLInputElement | null>
  handleTitleChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  titleValidationResult?: string | null
}

export const CreateIssueFormTitle = ({
  title,
  titleValidationResult,
  titleInputRef,
  handleTitleChange,
}: CreateIssueFormTitleProps) => {
  const {settings} = useViewerSettings()

  const textInput = (
    <TextInput
      ref={titleInputRef}
      aria-label={LABELS.issueCreateTitleLabel}
      placeholder={LABELS.issueCreateTitlePlaceholder}
      aria-describedby="issue-create-pane-title title-validation"
      value={title}
      onChange={handleTitleChange}
      {...hpcAttrs()}
      autoFocus
      data-react-autofocus
    />
  )

  return (
    <div className={styles.container}>
      <FormControl className={styles.formControl} required>
        <FormControl.Label className={styles.formControlLabel}>{LABELS.issueCreateTitleLabel}</FormControl.Label>
        <div className={styles.subcontainer}>
          <Suspense fallback={textInput}>
            <EmojiAutocomplete tone={settings.emojiTone}>{textInput}</EmojiAutocomplete>
          </Suspense>
          {titleValidationResult && (
            <span role="alert" aria-live="assertive">
              <FormControl.Validation variant="error" id="title-validation">
                {titleValidationResult}
              </FormControl.Validation>
            </span>
          )}
        </div>
      </FormControl>
    </div>
  )
}
